export default {
  created () {
    if (typeof this.index !== 'number') {
      throw new Error('programs/placements/state-mapper expects an "index" property for array updates')
    }
  },

  computed: {
    statePlacementStartDate: {
      get () {
        return this.placement.start_date
      },

      set (value) {
        this.setProgramProperty({ property: this._prefixProperty('start_date'), value })
      }
    },

    statePlacementEndDate: {
      get () {
        return this.placement.end_date
      },

      set (value) {
        this.setProgramProperty({ property: this._prefixProperty('end_date'), value })
      }
    },

    statePlacementStartComponentOpenDate: {
      get () {
        return this.placement.start_component_open_date
      },

      set (value) {
        this.setProgramProperty({ property: this._prefixProperty('start_component_open_date'), value })
      }
    },

    statePlacementStartComponentDueDate: {
      get () {
        return this.placement.start_component_due_date
      },

      set (value) {
        this.setProgramProperty({ property: this._prefixProperty('start_component_due_date'), value })
      }
    },

    statePlacementEndComponentOpenDate: {
      get () {
        return this.placement.end_component_open_date
      },

      set (value) {
        this.setProgramProperty({ property: this._prefixProperty('end_component_open_date'), value })
      }
    },

    statePlacementEndComponentDueDate: {
      get () {
        return this.placement.end_component_due_date
      },

      set (value) {
        this.setProgramProperty({ property: this._prefixProperty('end_component_due_date'), value })
      }
    },

    statePlacementMidPointCheckinOpenDate: {
      get () {
        return this.placement.mid_point_checkin_open_date
      },

      set (value) {
        this.setProgramProperty({ property: this._prefixProperty('mid_point_checkin_open_date'), value })
      }
    },

    statePlacementMidPointCheckinDueDate: {
      get () {
        return this.placement.mid_point_checkin_due_date
      },

      set (value) {
        this.setProgramProperty({ property: this._prefixProperty('mid_point_checkin_due_date'), value })
      }
    }
  },

  methods: {
    _prefixProperty (property) {
      return `placements.${this.index}.${property}`
    }
  }
}
